import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { useMutation, useQuery } from '@tanstack/react-query';
import { agreeEconsent, refundeeEconsentDetails } from '../services/direct';
import { ScrollArea } from './ui/scroll-area';
import { envs } from '../lib/constants';
import { Check } from 'lucide-react';
import { IconButton } from './ui/IconButton';
import { useTranslation } from 'react-i18next';
import SafeHtml from './SafeHtml';

export default function EConsentDialog() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const econsentQuery = useQuery({
    queryKey: ['econsentDetails'],
    queryFn: () => refundeeEconsentDetails(),
  });

  const agreeEconsentMutation = useMutation({
    mutationFn: agreeEconsent,
    onSuccess: () => {
      setOpen(false);
    },
  });

  useEffect(() => {
    if (
      econsentQuery.data &&
      econsentQuery.data?.isEconsentAgreed === false &&
      econsentQuery.data?.econsent?.enabled === true
    ) {
      setOpen(true);
    }
  }, [econsentQuery.data]);

  return (
    <Dialog open={open}>
      <DialogContent className='min-w-[50vw]'>
        <DialogHeader className='flex flex-row items-center justify-between'>
          <DialogTitle>{econsentQuery.data?.econsent?.title}</DialogTitle>
          {
            <img
              className='max-h-[40px]'
              src={envs.ASSETS_URL + econsentQuery.data?.econsent?.logo}
            />
          }
        </DialogHeader>
        <DialogDescription>
          {econsentQuery.data?.econsent?.heading}
        </DialogDescription>
        <ScrollArea className='h-[50vh] overflow-hidden rounded-md'>
          <DialogDescription className='bg-secondary p-4'>
            <SafeHtml html={econsentQuery.data?.econsent?.body ?? ''} />
          </DialogDescription>
        </ScrollArea>
        <DialogFooter className='pt-2'>
          <IconButton
            variant='success'
            isLoading={agreeEconsentMutation.isPending}
            Icon={Check}
            onClick={() => {
              agreeEconsentMutation.mutate();
            }}
          >
            {t('Accept')}
          </IconButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
